export function videoHolder() {
    let $videoHolder = $(".video-holder");
    let $window = $(window);
    let $body = $("body");
    $window.on("load scroll", function () {
        let scrollTop = $window.scrollTop();
        let windowHeight = $window.innerHeight();

        $videoHolder.each(function (i, it) {
            let offset = $(it).offset().top;
            if (scrollTop > offset - windowHeight && !$(it).hasClass("active") && !$(it).hasClass("open-on-click") && $body.hasClass("no-touch")) {
                if ($(it).hasClass("not-vimeo")) {
                    let video = $(it).find("video");
                    let videoScr = video.data("src");
                    video.find("source").attr("src", videoScr);
                    video[0].load();
                    video[0].play();
                } else {
                    let iframe = $(it).find("iframe");
                    let iframeScr = iframe.data("src");
                    iframe.attr("src", iframeScr);
                    setTimeout(function () {
                        unmuteVideo();
                    }, 1000);
                }

                $(it).addClass("active");
                setTimeout(function () {
                    $(it).find(".video-poster").addClass("hide");
                }, 1000);
            }
        });
    });
    $(".open-on-click").on("click", function () {
        let $this = $(this)

        if ($this.hasClass("not-vimeo")) {
            let video = $this.find("video");
            let videoScr = video.data("src");
            video.find("source").attr("src", videoScr);
            video[0].load();
            video[0].play();
        } else {
            let iframe = $this.find("iframe");
            let iframeScr = iframe.data("src");
            iframe.attr("src", iframeScr);
        }
        $this.addClass("active-video");
        setTimeout(function () {
            $this.find(".video-poster").addClass("hide");
        }, 500);
    });

    function unmuteVideo() {
        if ($(".mute-control").length) {
            let player = new Vimeo.Player(document.querySelector(".video-animation-wrap iframe"));
            $(".mute-control").on("click", function () {
                let $this = $(this);
                if ($this.hasClass("unmute")) {
                    $this.removeClass("unmute");
                    player.setVolume(0)
                } else {
                    $this.addClass("unmute");
                    player.setVolume(1);
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoHolder.js